import { ClaimableTypes } from '@models/InsuranceClaim';
import { OrderableTypes } from '@models/Order';
import { getRoute } from '@utils/route';

export const USER_DASHBOARD_ROUTE_URL = '/user-dashboard/*';

export const USER_DASHBOARD_POLICY_URL = '/user-dashboard/policy';
export const USER_DASHBOARD_OTP_URL = '/user-dashboard/otp';
export const USER_DASHBOARD_POLICY_DETAILS_URL = '/user-dashboard/policy/:orderableType/:orderableId';
export const USER_DASHBOARD_POLICY_CLAIM_URL = '/user-dashboard/policy/:orderableType/:orderableId/claim';
export const USER_DASHBOARD_POLICY_RENEWAL_URL = '/user-dashboard/policy/:orderableType/:orderableId/renewal';

type PolicyRouteParams = {
  orderableType: OrderableTypes;
  orderableId: number;
};

export const routeUserDashboardDetails = () => getRoute(USER_DASHBOARD_POLICY_URL);
export const routeUserDashboardOtp = () => getRoute(USER_DASHBOARD_OTP_URL);
export const routeUserDashboardPolicyDetails = (routeParams: PolicyRouteParams) =>
  getRoute(USER_DASHBOARD_POLICY_DETAILS_URL, { routeParams });
export const routeUserDashboardPolicyClaim = (routeParams: PolicyRouteParams, searchParams?: object) =>
  getRoute(USER_DASHBOARD_POLICY_CLAIM_URL, { routeParams, searchParams });
export const routeUserDashboardPolicyRenewal = (routeParams: PolicyRouteParams) =>
  getRoute(USER_DASHBOARD_POLICY_RENEWAL_URL, { routeParams });

export const USER_DASHBOARD_INSURANCE_CLAIM_LIST_PAGE_URL = '/user-dashboard/insurance-claim';
export const USER_DASHBOARD_INSURANCE_CLAIM_DETAILS_PAGE_URL = '/user-dashboard/insurance-claim/:claimableType/:claimableId';

export type ClaimRouteParams = {
  claimableType: ClaimableTypes;
  claimableId: number;
};

export const routeUserDashboardInsuranceClaimListPage = () => getRoute(USER_DASHBOARD_INSURANCE_CLAIM_LIST_PAGE_URL);
export const routeUserDashboardInsuranceClaimDetailsPage = (routeParams: ClaimRouteParams) =>
  getRoute(USER_DASHBOARD_INSURANCE_CLAIM_DETAILS_PAGE_URL, { routeParams });

export const USER_DASHBOARD_INSURANCE_POLICY_LIST_PAGE_URL = '/user-dashboard/insurance-policy';
export const USER_DASHBOARD_INSURANCE_POLICY_DETAILS_PAGE_URL = '/user-dashboard/insurance-policy/:insurancePolicyId';
export const USER_DASHBOARD_INSURANCE_POLICY_USER_DETAILS_PAGE_URL =
  '/user-dashboard/insurance-policy-user/:insurancePolicyUserId';
export const USER_DASHBOARD_INSURANCE_POLICY_CLAIM_URL = '/user-dashboard/insurance-policy/:insurancePolicyId/insurance-policy-user/:insurancePolicyUserId/claim';
export const USER_DASHBOARD_SEARCH_INSURANCE_POLICY_USER_PAGE_URL = '/user-dashboard/search-insurance-policy-user';

export const routeUserDashboardInsurancePolicyListPage = () => getRoute(USER_DASHBOARD_INSURANCE_POLICY_LIST_PAGE_URL);
export const routeUserDashboardInsurancePolicyDetailsPage = (routeParams: { insurancePolicyId: number }) => getRoute(USER_DASHBOARD_INSURANCE_POLICY_DETAILS_PAGE_URL, { routeParams });
export const routeUserDashboardInsurancePolicyUserDetailsPage = (routeParams: { insurancePolicyUserId: number }) => getRoute(USER_DASHBOARD_INSURANCE_POLICY_USER_DETAILS_PAGE_URL, { routeParams });
export const routeUserDashboardInsurancePolicyClaim = (routeParams: { insurancePolicyId: number; insurancePolicyUserId: number }) => getRoute(USER_DASHBOARD_INSURANCE_POLICY_CLAIM_URL, { routeParams });
export const routeUserDashboardSearchInsurancePolicyUserPage = () => getRoute(USER_DASHBOARD_SEARCH_INSURANCE_POLICY_USER_PAGE_URL);

export const USER_DASHBOARD_MOBILE_NUMBER_PAGE_URL = '/user-dashboard/mobile-number';

export const routeUserDashboardMobileNumberPage = () => getRoute(USER_DASHBOARD_MOBILE_NUMBER_PAGE_URL);

export const USER_DASHBOARD_PASSWORD_PAGE_URL = '/user-dashboard/password';

export const routeUserDashboardPasswordPage = () => getRoute(USER_DASHBOARD_PASSWORD_PAGE_URL);
